import { PAGE_TITLES } from 'admin/constants/qr-designer';

const hasNextPage = (page) => {
  return page < PAGE_TITLES.length - 1;
}

const hasPreviousPage = (page) => {
  return page > 0;
}

export const getNextPage = (page) => {
  return hasNextPage(page) ? page + 1 : page;
}

export const getPreviousPage = (page) => {
  return hasPreviousPage(page) ? page - 1 : page;
}
